module.exports = __webpack_public_path__ + "static/img/work-idea-bg.c5e1c22.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/work-idea-bg.jpg
// module id = EWee
// module chunks = 1